import { BrandPage, SidebarLayout, ToastList } from "@dgs/core";
import { FC } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { ActivityPage } from "~root/activities/ActivityPage";
import { EmployeeDashboardPage } from "~root/employeeDashboard/EmployeeDashboardPage";
import { Header } from "~root/header";
import { OffDaysPage } from "~root/offDays/OffDaysPage";
import { OwnPayrollsList } from "~root/payrolls/OwnPayrollsList";
import { PayrollsList } from "~root/payrolls/PayrollsList";
import { ProjectPage } from "~root/projects/ProjectPage";
import { RoleListPage } from "~root/roles/RoleListPage";
import { Sidebar } from "~root/sidebar";
import { TimesList } from "~root/times/TimesList";
import { DefaultContentLayout } from "~shared/layout";
import { BranchList } from "./branches/BranchList";
import { EmployeePage } from "./employees/EmployeePage";
import { ContentProviders } from "./providers/ContentProviders";
import { TeamsPage } from "./teams/TeamsPage";
import { OwnTimesList } from "./times/OwnTimesList";
import { UserListPage } from "./users/UserListPage";
import { OwnVacationList } from "./vacations/OwnVacationList";
import { VacationList } from "./vacations/VacationList";

export const Content: FC = () => {
	return (
		<ContentProviders>
			<ToastList />
			<SidebarLayout
				header={<Header />}
				sideBar={<Sidebar />}
				content={
					<Routes>
						<Route
							element={
								<DefaultContentLayout>
									<Outlet />
								</DefaultContentLayout>
							}
						>
							<Route index element={<Navigate replace to="vacations" />} />
							<Route path="users-roles/*" index element={<UsersRolesPage />} />
							<Route path="branches" element={<BranchList />} />
							<Route path="teams" element={<TeamsPage />} />
							<Route path="off-days" element={<OffDaysPage />} />
							<Route path="brand" element={<BrandPage frontendThemeName="dgs" />} />
							<Route path="times">
								<Route index element={<Navigate replace to="own" />} />
								<Route path="all" element={<TimesList />} />
								<Route path="own" element={<OwnTimesList />} />
							</Route>
							<Route path="vacations">
								<Route index element={<Navigate replace to="own" />} />
								<Route path="all" element={<VacationList />} />
								<Route path="own" element={<OwnVacationList />} />
							</Route>
							<Route path="payrolls">
								<Route index element={<Navigate replace to="own" />} />
								<Route path="all" element={<PayrollsList />} />
								<Route path="own" element={<OwnPayrollsList />} />
							</Route>
							<Route path="dashboard" element={<EmployeeDashboardPage />} />
						</Route>
						<Route path="employees/*" index element={<EmployeePage />} />
						<Route path="projects/*" index element={<ProjectPage />} />
						<Route path="activities/*" index element={<ActivityPage />} />
					</Routes>
				}
			/>
		</ContentProviders>
	);
};

const UsersRolesPage = () => {
	return (
		<Routes>
			<Route path="users" element={<UserListPage />} />
			<Route path="roles" element={<RoleListPage />} />
			<Route path="*" element={<Navigate to="users" replace />} />
		</Routes>
	);
};
